var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CTabs',{attrs:{"variant":"enclosed-colored","variant-color":"green"}},[_c('CTabList',[_c('CTab',[_vm._v(" "+_vm._s(_vm.title)+" ")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }